<template>
  <div class="portal">
    <div class="menu">
      <div @click="changeOption(0)" class="menu-info">
        <div class="menu-logo">
          <a v-if="schoolInfo.imgUrl"><img :src="schoolInfo.imgUrl" /></a>
          <a v-else><span>课后三点半</span></a>
        </div>
        <div class="menu-line"></div>
        <div class="menu-schoolName">
          <a>{{ schoolInfo.schoolName }}</a>
        </div>
      </div>
      <div class="menu-option min500">
        <div
          v-for="(item, index) in optionList"
          :key="index"
          @click="changeOption(index)"
          class="menu-option-inner"
        >
          <span :class="{ 'c-189': optionCur == index }">{{ item.name }}</span>
          <div :class="{ 'menu-option-sel': optionCur == index }"></div>
        </div>
      </div>
      <div class="menu-option max500">
        <a-dropdown v-model="menuShow" placement="bottomRight">
          <div @click="openDropdown()">{{ optionList[optionCur].name }} ▼</div>
          <a-menu slot="overlay">
            <a-menu-item
              v-for="(item, index) in optionList"
              :key="index"
              @click="changeOption($event, 'drop')"
            >
              <a>{{ item.name }}</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
    </div>
    <router-view @changeOption="changeOption" />
    <!-- <div class="support-box"></div> -->
    <div class="support">
      <div>由 米果智能（上海）科技提供技术平台服务</div>
      <a
        href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
        target="_blank"
        >沪ICP备 14023729号-5</a
      >
    </div>
  </div>
</template>
<script>
import gateway from '../../api/gateway'
export default {
  name: 'gateway',
  data() {
    return {
      schoolInfo: {},
      optionList: [
        {
          id: 1,
          name: '首页',
          route: 'portal',
        },
        {
          id: 2,
          name: '课程',
          route: 'course',
        },
        {
          id: 3,
          name: '家长小程序',
          route: 'parent',
        },
        {
          id: 4,
          name: '更多应用',
          route: 'more',
        },
      ],
      optionCur: 0,
      menuShow: false,
    }
  },
  created() {
    const url = location.href
    const idx = this.optionList.findIndex((i) => url.includes(i.route))
    this.optionCur = idx == -1 ? 0 : idx
    this.getSchoolInfo()
  },
  methods: {
    getSchoolInfo() {
      gateway
        .getSchoolInitData()
        .then((res) => {
          this.schoolInfo = res.data.schoolInfo
        })
        .catch((err) => {
          this.$router.push('/portal')
        })
    },
    changeOption(idx, type) {
      this.menuShow = false
      if (type == 'drop') this.optionCur = idx.key
      else this.optionCur = idx
      this.$router.push(this.optionList[this.optionCur].route)
    },
    openDropdown() {
      this.menuShow = !this.menuShow
    },
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';

// html body {
// 	width: 100%;
// 	height: 100%;
// 	background: '#000000';
// }

@media screen and (min-width: 510px) {
  .portal {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;

    .menu {
      width: 100%;
      max-width: 1100px;
      @media screen and (min-width: 1441px) {
        max-width: 1500px;
      }
      height: 96px;
      min-height: 96px;
      font-weight: 600;
      background-color: #ffffff;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .menu-info {
        display: flex;
        align-items: center;

        .menu-logo {
          img {
            width: 50px;
            height: 50px;
            object-fit: cover;
          }

          span {
            font-size: 32px;
          }
        }

        .menu-line {
          width: 2px;
          height: 24px;
          background-color: #d8d8d8;
          margin: 0 12px;
        }

        .menu-schoolName {
          font-size: 24px;
          a {
            color: #666666;
          }
        }
      }

      .menu-option {
        display: flex;

        .menu-option-inner {
          font-size: 16px;
          text-align: center;
          margin-left: 40px;
          cursor: pointer;

          .c-189 {
            color: #1890ff;
          }

          .menu-option-sel {
            background-color: #1890ff;
          }

          a {
            color: #000000;
          }

          div {
            width: 100%;
            height: 4px;
            margin: 5px auto 0;
          }
        }
      }

      .max500 {
        display: none;
      }
    }

    .support {
      width: 100%;
      min-height: 80px;
      height: 80px;
      font-size: 16px;
      color: #606266;
      padding: 0 220px;
      background-color: #eaedf5;
      display: flex;
      align-items: center;
      justify-content: space-between;
      // position: sticky;
      // bottom: 0;
      // left: 0;
      margin-top: auto;

      a {
        color: #606266;
      }
    }

    .support-box {
      // width: 100%;
      // height: 80px;
    }
  }
}

@media screen and (max-width: 510px) {
  .menu {
    width: 100%;
    height: 60px;
    font-weight: 600;
    padding: 0 15px;
    background-color: #ffffff;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .menu-info {
      flex: 1;
      display: flex;
      align-items: center;

      .menu-logo {
        img {
          width: 32px;
          height: 32px;
          object-fit: cover;
        }

        span {
          font-size: 16px;
        }
      }

      .menu-line {
        width: 2px;
        height: 24px;
        background-color: #d8d8d8;
        margin: 0 12px;
      }

      .menu-schoolName {
        flex: 1;
        font-size: 14px;
        color: #666666;
        margin-right: 12px;
      }
    }

    .menu-option {
    }

    .min500 {
      display: none;
    }
  }

  .support {
    width: 100%;
    height: 60px;
    font-size: 8px;
    color: #606266;
    padding: 0 15px;
    background-color: #eaedf5;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    a {
      color: #606266;
    }
  }
}
</style>
